// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deck-global-left-nav {
  -webkit-font-smoothing: antialiased;
}
.deck-global-left-nav .nkl-deck-left-nav-primary {
  opacity: 0;
  transform: translateX(-50%);
  transition: all 250ms ease-out;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
.deck-global-left-nav .nkl-deck-left-nav-secondary {
  opacity: 0;
  transform: translateX(-75%);
  transition: all 300ms ease-out;
}
.deck-global-left-nav.is-loaded .nkl-deck-left-nav-primary,
.deck-global-left-nav.is-loaded .nkl-deck-left-nav-secondary {
  opacity: 1;
  transform: translateX(0);
  border: none;
}
.deck-global-left-nav .close-icon {
  display: none;
}
@media screen and (max-width: 735px) {
  .deck-global-left-nav .close-icon {
    display: flex;
    margin-top: 6px;
    width: 100%;
    justify-content: flex-end;
    margin-bottom: 11px;
    color: #59606D;
  }
  .deck-global-left-nav .close-icon svg {
    cursor: pointer;
    margin-right: 30px;
  }
}
.nkl-deck-left-nav-primary.ant-menu {
  padding-bottom: 60px;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item {
  font-size: 16px;
  font-weight: 400;
  border-radius: 6px;
  margin: 0;
  padding: 14px;
  line-height: 24px;
  text-transform: capitalize;
  margin-bottom: 8px;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item.disabled {
  color: #b1baca;
  cursor: not-allowed;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item:hover {
  background-color: #F5F7FA;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item.ant-menu-item-selected {
  background-color: #F5F7FA;
  font-weight: 700;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item svg {
  min-width: 24px;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-item.menu-item .ant-menu-title-content {
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item {
  padding-left: 0;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item .ant-menu-submenu-title {
  margin-inline: 0;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item .ant-menu-submenu-title .ant-menu-title-content {
  font-weight: 400;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item.ant-menu-submenu-selected .ant-menu-submenu-title {
  color: black;
}
.nkl-deck-left-nav-primary.ant-menu .ant-menu-submenu-inline.menu-item.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-title-content {
  font-weight: 700;
}
.nkl-deck-left-nav-secondary.ant-menu .ant-menu-item.menu-item {
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  border-radius: 4px;
  margin: 0;
  padding: 10px 14px;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
